import { ReactComponent as ChervronRight } from "assets/chevron-right.svg";
import { ReactComponent as LanguageIcon } from "assets/language.svg";
import { CountryFlag } from "components/CountryFlag/CountryFlag";
import { useModifiedTranslation } from "hooks/useModifiedTranslation";
import { useTranslation } from "react-i18next";

interface LanguageSelectionProps {
  languageMenuOpen: boolean;
  setLanguageMenuOpen: (b: boolean) => void;
}

export const LanguageSelection = ({
  languageMenuOpen,
  setLanguageMenuOpen,
}: LanguageSelectionProps) => {
  const { i18n } = useTranslation();

  const selectLanguage = (lang: string) => {
    localStorage.setItem("locale", lang);
    i18n.changeLanguage(lang);
    setLanguageMenuOpen(!languageMenuOpen);
  };

  const MenuOpen = () => {
    return (
      <div className="font-base">
        <div
          onClick={() => selectLanguage("en-US")}
          className="py-2 px-8 flex gap-2 items-center w-full text-base text-gray-900 border-primary-100 border-b-2 last:border-0 cursor-pointer hover:bg-primary-50 hover:text-brand"
        >
          <CountryFlag
            code="gb"
            className="inline align-baseline w-[20px] h-[14px] "
          />{" "}
          English
        </div>
        <div
          onClick={() => selectLanguage("fi-FI")}
          className="py-2 px-8 flex gap-2 items-center w-full text-base text-gray-900 border-primary-100 border-b-2 last:border-0 cursor-pointer hover:bg-primary-50 hover:text-brand"
        >
          <CountryFlag
            code="fi"
            className="inline align-baseline w-[20px] h-[14px]"
          />{" "}
          Suomi
        </div>
        <div
          onClick={() => selectLanguage("sv-SE")}
          className="py-2 px-8 flex gap-2 items-center w-full text-base text-gray-900 border-primary-100 border-b-2 cursor-pointer hover:bg-primary-50 hover:text-brand"
        >
          <CountryFlag
            code="se"
            className="inline align-baseline w-[20px] h-[14px]"
          />{" "}
          Svenska
        </div>
      </div>
    );
  };

  const { t } = useModifiedTranslation();
  return (
    <div>
      <div
        className={`py-2 px-4 flex gap-2 items-center w-full text-base font-medium text-gray-900 border-primary-100 ${
          !languageMenuOpen && "border-b-2"
        } cursor-pointer justify-between hover:bg-primary-50 hover:text-brand`}
        onClick={() => setLanguageMenuOpen(!languageMenuOpen)}
      >
        <div className="flex items-center gap-1">
          <LanguageIcon className="w-5 h-5" /> {t("userMenu.language")}
        </div>{" "}
        <ChervronRight
          className={`w-5 h-5 ${
            languageMenuOpen && "-rotate-90 transition-all"
          }`}
        />
      </div>
      {languageMenuOpen && <MenuOpen />}
    </div>
  );
};
